import { Button } from "@/components/ui/button";
import { Check, ArrowRight, Sparkles } from "lucide-react";

const features = [
  "Your personalized QCard profile",
  "Photo, name, title & company",
  "Phone, email & website links",
  "All your social media profiles",
  'Instant "Add to Contacts" button',
  "Shareable QR code",
  "Personal link (qcard.me/you)",
  "Unlimited sharing",
];

const FreeTierSection = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl -z-10" />
      
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-green-500/10 text-green-600 text-sm font-semibold mb-4">
              ✓ Completely Free
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              Professional Identity.{" "}
              <span className="text-gradient">Zero Cost.</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              While others charge $10-20/month, QCard gives you a complete professional profile 
              <strong className="text-foreground"> absolutely free</strong>. Try it now — setup takes 60 seconds.
            </p>
          </div>

          {/* Card */}
          <div className="relative">
            {/* Glow */}
            <div className="absolute inset-0 gradient-primary opacity-20 blur-3xl rounded-3xl" />
            
            <div className="relative bg-card rounded-3xl border border-primary/20 overflow-hidden shadow-2xl">
              {/* Header */}
              <div className="gradient-primary px-8 py-6">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2 text-white/80 text-sm mb-1">
                      <Sparkles className="w-4 h-4" />
                      QCard Free
                    </div>
                    <div className="flex items-baseline gap-2">
                      <span className="text-5xl font-bold text-white">$0</span>
                      <span className="text-white/70">/forever</span>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-white/60 text-sm line-through">$12/month</div>
                    <div className="text-white font-semibold">Save $144/year</div>
                  </div>
                </div>
              </div>

              {/* Features */}
              <div className="p-8">
                <div className="grid sm:grid-cols-2 gap-4 mb-8">
                  {features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-3">
                      <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                        <Check className="w-4 h-4 text-primary" />
                      </div>
                      <span className="text-foreground">{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA */}
                <div className="text-center">
                  <Button size="lg" className="gradient-primary text-white hover:opacity-90 text-lg px-12 py-6 font-semibold shadow-lg hover:shadow-xl transition-all">
                    Start Free — Takes 60 Seconds
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                  <p className="mt-4 text-sm text-muted-foreground">
                    No credit card. No hidden fees. Just a polished professional profile.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Badge */}
          <div className="mt-12 text-center">
            <p className="text-muted-foreground text-sm">
              Built for professionals in <span className="text-primary font-semibold">Real Estate, Finance, Consulting, and more</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeTierSection;
